import { MSL_HOST_CONFIG } from './msl'
import { HOST_NAMES, HostBranding, HostConfig } from './types'
import { GAMBYT_DEMO_HOST_CONFIG } from './gambyt-demo.tsx'

/**
 * Each host config is read through a getter so it resolves on access rather than when this module
 * evaluates. The configs import screen components, those components import `useHostConfig`, and that
 * hook imports this module — a cycle in which an eagerly built map captures `undefined` for whichever
 * config has not finished evaluating yet, depending on which module the entry point reaches first.
 */
export const hostConfigByName: Record<HOST_NAMES, HostConfig> = {
  get [HOST_NAMES.MSL]() {
    return MSL_HOST_CONFIG
  },
  get [HOST_NAMES.GAMBYT_DEMO]() {
    return GAMBYT_DEMO_HOST_CONFIG
  },
}

/**
 * Brand values keyed by the CSS custom property each one sets. The stylesheets declare the same
 * properties with fallback values, so anything omitted here keeps its declared default.
 */
function brandingCustomProperties(branding: HostBranding): Record<string, string> {
  return {
    '--brand-color': branding.brandColor,
    '--navigation-font-color': branding.navigationFontColor,
    '--cta-color': branding.ctaColor,
    '--accent-color': branding.accentColor,
    '--background-color': branding.backgroundColor,
    '--font-family': `'${branding.fontFamily}'`,
  }
}

export const ConfigUtils = {
  brandingCustomProperties,
}
